export const time = 60e3;
export const grading = ["Incorrect", "Correct"];
